export const THEME_STORAGE_KEY = 'super-mega-theme'
export const THEME_COLOR_STORAGE_KEY = 'super-mega-theme-color'
